import { HorizontalContainer } from '@/components/containers/HorizontalContainer';
import { FileEntity } from './types';
import { FileUploadBox } from './FileUploadBox';
import classNames from 'classnames';

type AttachmentsListProps = {
    files: FileEntity[];
    className?: string;
    onRemoveCallback: (identifier: string) => void;
};

export const AttachmentsList = ({
    files,
    className,
    onRemoveCallback,
}: AttachmentsListProps) => {
    if (!files || files.length === 0) {
        return null;
    }

    return (
        <HorizontalContainer
            className={classNames('flex-wrap', className)}
            spacing="md"
        >
            {files.map((fileEntity) => (
                <FileUploadBox
                    fileEntity={fileEntity}
                    key={fileEntity.identifier}
                    onRemoveCallback={onRemoveCallback}
                />
            ))}
        </HorizontalContainer>
    );
};
